import React from 'react'
import { Chip } from 'lune-ui-lib'
import { SxProps } from '@mui/material'
import VolunteerActivismOutlinedIcon from '@mui/icons-material/VolunteerActivismOutlined'

const ForYourSustainabilityTeam = ({ sx }: { sx?: SxProps }) => {
    return (
        <Chip
            sx={{ ...sx, maxWidth: 'max-content' }}
            label={'For your sustainability team'}
            icon={<VolunteerActivismOutlinedIcon />}
        />
    )
}

export default ForYourSustainabilityTeam
